export class SaveNewUserOnNotificationsError extends Error {
    public readonly name: string;
    public readonly stack: string;

    constructor(message: string, stack: string = '') {
        super(message);
        this.name = 'SaveNewUserOnNotificationServiceError';
        this.stack = stack;
        Object.setPrototypeOf(this, SaveNewUserOnNotificationsError.prototype);
    }
}
